import { render, staticRenderFns } from "./selProductList.vue?vue&type=template&id=30604dfa&scoped=true"
import script from "./selProductList.vue?vue&type=script&lang=js"
export * from "./selProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30604dfa",
  null
  
)

export default component.exports